import { render, staticRenderFns } from "./tableModalTips.vue?vue&type=template&id=c2ab8e24&"
import script from "./tableModalTips.vue?vue&type=script&lang=js&"
export * from "./tableModalTips.vue?vue&type=script&lang=js&"
import style0 from "./tableModalTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports